module.exports = __webpack_public_path__ + "static/media/lantern.da2c78c4.jpg";